import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

type AudioTTSStatus = "processing" | "completed" | "failed";

export interface AudioTTSCreateParams {
  text: string;
  voice_id: string;
  point: number;
  speed_ratio?: number;
  marks: {
    type: string;
    indexRange: number[];
    text: string;
  }[];
}

export interface AudioTTSCreateProps {
  text: string;
  voiceId: string;
  point: number;
  speedRatio?: number;
  marks: {
    type: string;
    indexRange: number[];
    text: string;
  }[];
}

interface AudioTTSCreateResponse {
  task_id: string;
  status: AudioTTSStatus;
}

export class AudioTTSCreateData {
  @Required("Task ID cannot be empty")
  @IsString("Task ID must be a string")
  taskId: string;

  @Required("Status cannot be empty")
  @IsString("Status must be a string")
  status: AudioTTSStatus;
}

const transformAndValidateAudioTTSCreate = (
  response: AudioTTSCreateResponse
): AudioTTSCreateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AudioTTSCreateData);
  } catch (error) {
    console.error("Audio TTS create data validation failed:", error.message);
    throw error;
  }
};

// 创建音频TTS任务（文本合成语音任务）
export const audioTTSCreate = async (
  props: AudioTTSCreateProps
): Promise<AudioTTSCreateData> => {
  if (!props.voiceId) {
    throw new Error("Voice ID is required");
  }
  const params: AudioTTSCreateParams = {
    text: props.text,
    voice_id: props.voiceId,
    point: props.point,
    speed_ratio: props.speedRatio,
    marks: props.marks.map((mark) => ({
      type: mark.type,
      indexRange: mark.indexRange,
      text: mark.text,
    })),
  };
  const response = await api.post<AudioTTSCreateResponse>("/audio/tts/create", params);
  return transformAndValidateAudioTTSCreate(response.data);
};
